/**
 * Labstep
 */

import type { CalendarOptions, PluginDef } from '@fullcalendar/core';

export enum IPluginName {
  timeline = 'timeline',
  timeGrid = 'timeGrid',
}

export type IAvailablePlugins = {
  [key in IPluginName]: PluginDef[];
};

export interface IFullCalendarProps extends CalendarOptions {
  ref?: any;
  isGrid?: boolean;
  pluginName: IPluginName;
  className?: string;
  isTimeline?: boolean;
}
